const RP_FORMATTER = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
});

const COMPACT_RP_FORMATTER = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function formatIDR(amount: number): string {
  return RP_FORMATTER.format(amount);
}

export function formatIDRCompact(amount: number): string {
  // Indonesian convention: 1.000.000 = 1 juta. Use custom labels for "juta" feel.
  if (amount >= 1_000_000_000) {
    const m = amount / 1_000_000_000;
    return `Rp${m.toFixed(m < 10 ? 1 : 0)} M`;
  }
  if (amount >= 1_000_000) {
    const m = amount / 1_000_000;
    return `Rp${m.toFixed(m < 10 ? 1 : 0)} jt`;
  }
  if (amount >= 1_000) {
    const k = amount / 1_000;
    return `Rp${k.toFixed(0)} rb`;
  }
  return COMPACT_RP_FORMATTER.format(amount);
}

export function formatDateID(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return new Intl.DateTimeFormat('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(d);
}
